var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dl",
    { staticClass: "c-key-value" },
    [
      _vm._l(_vm.items, function(item) {
        return [
          _vm.semiColon
            ? _c("dt", { key: item.key, staticClass: "c-key-value__key" }, [
                _vm._v("\n\t\t\t" + _vm._s(item.key) + ":\n\t\t")
              ])
            : _c("dt", { key: item.key, staticClass: "c-key-value__key" }, [
                _vm._v("\n\t\t\t" + _vm._s(item.key) + "\n\t\t")
              ]),
          _vm._v(" "),
          _vm._l(item.value, function(value) {
            return _c("dd", {
              key: value,
              staticClass: "c-key-value__value",
              domProps: { innerHTML: _vm._s(value) }
            })
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }